export function formatRub(value) {
  if (value == null || isNaN(value)) return "0 ₽"; // защита от мусора
  return `${Math.round(value).toLocaleString("ru-RU")} ₽`;
}
